module.exports = __webpack_public_path__ + "img/icon-demo.44e57002.svg";